import {gql} from '@apollo/client';

/**
 * 预约单「实际入库包裹」明细。
 *
 * 与 `getAppointmentParcels`（预计揽收包裹 = 挂载运单全量）是**两个口径**，不可互换：
 * 本接口按「揽收站点 + 到仓扫描归属日」取数，条数严格等于列表「实际入库包裹数量」那一列。
 * 两者可以差很多——生产实测同一张单挂载 1 件、实际入库 166 件。
 *
 * 同站点同日的常规单只有一张会被计入，非归属单返回空数组（此时它的计数也是 0）。
 */
export const GET_APPOINTMENT_INBOUND_PARCELS = gql`
  query GetAppointmentInboundParcels($id: Long!) {
    getAppointmentInboundParcels(id: $id) {
      orderId
      trackingNumber
      overallStatus
      arrivalScanAt
    }
  }
`;

export interface InboundParcelItem {
    orderId: string;
    /** 后端允许为空（order.tracking_number 可空） */
    trackingNumber: string | null;
    /** 枚举名；库中值不在枚举内时后端返回 null */
    overallStatus: string | null;
    /**
     * 入库（ASCAN）时间，UTC epoch 秒。与入库计数是同一次写入，正常恒有值；
     * 留可空只为防御脏数据，前端取不到时显示 --。
     */
    arrivalScanAt: number | null;
}

export interface GetAppointmentInboundParcelsResponse {
    getAppointmentInboundParcels: InboundParcelItem[];
}

export interface GetAppointmentInboundParcelsVariables {
    id: number;
}
